<template>
  <div class="ProposedOfferCardContainer">
    <HotOfferCard
      v-bind="$attrs"
      :tag-type="cptdOfferTag.type"
      :tag-label="cptdOfferTag.label"
      :interest-rate="
        offer.display_interest_rate_monthly || offer.interest_rate_monthly || 0
      "
      :installment-value="offer.installment_amount"
      :duration="offer.duration"
      :amount="offer.amount"
      :partner="offer.partner"
    />
    <slot name="modal" />
  </div>
</template>
<script>
import { OfferStatus } from '@/data/common'
import { UIFeedbackTypes } from '@/helpers/offer-types'
import HotOfferCard from '~/aasgard/components/cards/HotOfferCard.vue'
export default {
  name: 'ProposedOfferCardContainer',
  components: {
    HotOfferCard,
  },
  props: {
    tag: { type: Object, default: undefined },
    offer: { type: Object, required: true },
  },
  computed: {
    cptdOfferTag() {
      if (this.tag) {
        return this.tag
      }
      switch (this.offer.status) {
        case OfferStatus.PROPOSED:
          return {
            label: 'Oferta pré-aprovada',
            type: UIFeedbackTypes['POSITIVE-LIGHT'],
          }
        default:
          return null
      }
    },
  },
}
</script>
